export enum FINISH {
    MATTE = 'matte-finish',
    SATIN = 'satin-finish',
    SHINE = 'shine-finish',
    NATURAL = 'natural-finish',
    SHIMMER = 'shimmer-finish'
}
